// src/types/search.types.ts

import { NewsArticle, EventArticle } from './news.types';
import { Form } from './form.types';

export interface Site {
  id: string;
  name: string;
  address: string;
  images?: string[];
  description?: string;
  studentCount?: number;
}

export interface InstitutionalDocument {
  id: string;
  title: string;
  description?: string;
  url: string;
  category?: string;
}

export interface SearchResults {
  news: NewsArticle[];
  events: EventArticle[];
  institutional: InstitutionalDocument[];
  sites: Site[];
  forms: Form[];
}

export interface SearchState {
  query: string;
  results: SearchResults;
  loading: boolean;
  error: string | null;
  activeTab: SearchTab;
}

export enum SearchTab {
  ALL = 'all',
  NEWS = 'news',
  EVENTS = 'events',
  INSTITUTIONAL = 'institutional',
  SITES = 'sites',
  FORMS = 'forms',
}

export interface SearchFilters {
  query: string;
  contentTypes?: SearchTab[];
}
